import api from '../axios';

export async function listarGCs(params) {
  const res = await api.get('/grupos-crescimento/', { params });
  return res.data;
}

export async function getGC(id) {
  const res = await api.get(`/grupos-crescimento/${id}`);
  return res.data;
}

export async function criarGC(data) {
  const res = await api.post('/grupos-crescimento/', data);
  return res.data;
}

export async function atualizarGC(id, data) {
  const res = await api.put(`/grupos-crescimento/${id}`, data);
  return res.data;
}

export async function deletarGC(id) {
  const res = await api.delete(`/grupos-crescimento/${id}`);
  return res.data;
}

export async function aprovarGC(id) {
  const res = await api.post(`/grupos-crescimento/${id}/aprovar`);
  return res.data;
}

export async function listarMembrosGC(id) {
  const res = await api.get(`/grupos-crescimento/${id}/membros`);
  return res.data;
}

export async function adicionarMembroGC(gcId, membroId) {
  const res = await api.post(`/grupos-crescimento/${gcId}/membros`, { membro_id: membroId });
  return res.data;
}

export async function adicionarVisitanteGC(gcId, nome, contato) {
  const res = await api.post(`/grupos-crescimento/${gcId}/membros`, { nome_externo: nome, contato_externo: contato });
  return res.data;
}

export async function removerMembroGC(gcId, membroGcId) {
  const res = await api.delete(`/grupos-crescimento/${gcId}/membros/${membroGcId}`);
  return res.data;
}

export async function dashboardGCs() {
  const res = await api.get('/grupos-crescimento/dashboard');
  return res.data;
}

export async function membrosSemGC() {
  const res = await api.get('/grupos-crescimento/membros-sem-gc');
  return res.data;
}
